export enum AppPermission {
  Pay = 'Pagar',
  EditRol = 'EditarRol',
  BlockPackageFee = 'BloquearTarifaPaquete',
  AccessShoppingCar = 'AccesoCarritoCompras',
  AddNewFee = 'Agregartarifanueva',
  CreateRol = 'Crearnuevorol',
  EditFee = 'Editartarifa',
  EditIndividualGuideFee = 'Editartarifaguíaindividual',
  SelectStore = 'SeleccionarTienda',
  AddInvoicingAddress = 'Agregardireccionfacturación',
  DeleteRol = 'Eliminarrol',
  DeleteFee = 'Eliminartarifa',
  PaymentSummary = 'ResumendePago',
  DownloadUserDetail = 'DescargarDetalleUsuario',
  AddNewPackageFee = 'Agregartarifanuevapaquete',
  EditInvoicingAddress = 'Editardirecciónfacturación',
  EditUser = 'EditarUsuario',
  TerminalPayment = 'PagoTerminal',
  BlockFee = 'Bloqueartarifa',
  BulkLoad = 'CargaMasiva',
  AccessPaymentType = 'Accesotipopago',
  DeletePackageFee = 'Eliminartarifapaquete',
  ConsultODCDetail = 'VerDetalleODC',
  AccessPackagesHome = 'Accesohomepaquetes',
  TdcTddPayment = 'PagoTDC/TDD',
  ConsultInvoice = 'VerFactura',
  DeleteInvoicingAddress = 'Eliminardirecciónfacturación',
  EditPackageFee = 'Editartarifapaquete',
  RolAdmin = 'AdministracionRoles',
  CreateNewUser = 'CrearNuevoUsuario',
  BlockUser = 'BloquearUsuario',
  ConsultUserDetial = 'ConsultarDetalleUsuario',
  Invoicing = 'Facturar',
  TransferPayment = 'PagoTransferencia',
  DownloadPaymentPDF = 'DescargarPDFPago',
  ConsultClientActiveReports = 'ConsultarReportesActivosCliente',
  ConsultClientInactiveReports = 'ConsultarReportesInactivosCliente',
  DownloadClientReports = 'DescargarReportesCliente',
  EditClientReports = 'EditarReportesCliente',
  BlockClientReports = 'DeshabilitarReportesCliente',
  EnableClientReports = 'HabilitarReportesCliente',
  CreateClientReports = 'AltaReportesCliente',
  ConsultDHLActiveReports = 'ConsultarReportesActivosEmpleadosDhl',
  ConsultDHLInactiveReports = 'ConsultarReportesInactivosEmpleadosDhl',
  DownloadDHLReports = 'DescargarReportesEmpleadosDhl',
  EditDHLReports = 'EditarReportesEmpleadosDhl',
  BlockDHLReports = 'DeshabilitarReportesEmpleadosDhl',
  EnableDHLReports = 'HabilitarReportesEmpleadosDhl',
  CreateDHLReports = 'AltaReportesEmpleadosDhl'
}
